import React from 'react'
import { Modal } from '@/shared/ui'
import InstallInstructionsContent from './InstallInstructionsContent'

export default function InstallInstructionsModal({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <div className="space-y-3">
        <h3 className="text-base font-semibold">Como instalar o app</h3>
        <InstallInstructionsContent />
      </div>
    </Modal>
  )
}
